import { LOAD_UI, WAIT_UI, HIDE_PAX_TOOLTIP } from 'app/store/actions';

const defaultState = {
    loading: true,
    paxTooltipVisible: true,
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case LOAD_UI:
            return {
                ...state,
                loading: false,
            };
        case WAIT_UI:
            return {
                ...state,
                loading: true,
            };
        case HIDE_PAX_TOOLTIP:
            return {
                ...state,
                paxTooltipVisible: false,
            };
        default:
            return state;
    }
};
